import * as React from 'react';

import { observer } from 'mobx-react';

import { ITranslationsCollection } from '@estee/elc-service';
import { Body1 } from '@estee/elc-typography';

import classnames from 'classnames';

import { IMessage } from '~repositories/MessageRepository';
import { classes } from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';

export interface IMessagePanelProps {
    messages?: IMessage[];
    translations?: ITranslationsCollection;
    className?: string;
}

export const MessagePanel: React.FunctionComponent<IMessagePanelProps> = observer(
    (props: IMessagePanelProps) => {
        const { messages, className } = props;
        const translations = useTranslation();

        if (!messages || messages.length === 0) {
            return null;
        }
        const msgType = messages[0].msgType || 'error';
        const msgMessageClassNames = classes(`iam-${msgType}-message`, 'iam-message');
        const msgPanelClassNames = classnames(
            classes(`iam-${msgType}-panel`),
            className,
            'iam-message-panel'
        );
        const msgListClassNames = classes(`iam-${msgType}-list`);

        const messageItems = messages.map(({ message, transKey = '' }, index) => {
            const msgContent = message || (transKey && translations[transKey]);

            return (
                <li key={`${msgType}-${index}`} className={msgMessageClassNames}>
                    <Body1>{msgContent}</Body1>
                </li>
            );
        });

        return (
            <div className={msgPanelClassNames}>
                <ul className={msgListClassNames}>{messageItems}</ul>
            </div>
        );
    }
);
